import {BaseTerms} from "../../infrastructure/models/base-terms";

export class NavigationTabsModuleTerms extends BaseTerms {
  SEO_INSEASON_NAME_ENTITY_TAB = "In-Season Tournament";
  SEO_NBA_NAME_ENTITY_TAB = "NBA";
  WEB_ODDS_TAB_GAME_PAGE = "Odds";
  COMPETITION_ODDS_TAB_NAME = "Odds";
}
